/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What accuracy does Q30 mean?`)
};

const es_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué precisión significa Q30?`)
};

const de_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Genauigkeit bedeutet Q30?`)
};

const nl_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke nauwkeurigheid betekent Q30?`)
};

const fr_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle précision signifie Q30 ?`)
};

const it_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significa un'accuratezza Q30?`)
};

const pt_br2_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que precisão o Q30 representa?`)
};

const pt_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que precisão significa Q30?`)
};

const ja_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30はどのような精度を意味しますか？`)
};

const zh_phred_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Q30 意味着什么准确率？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_faq_q3", locale)
	if (locale === "en") return en_phred_faq_q3(inputs)
	if (locale === "es") return es_phred_faq_q3(inputs)
	if (locale === "de") return de_phred_faq_q3(inputs)
	if (locale === "nl") return nl_phred_faq_q3(inputs)
	if (locale === "fr") return fr_phred_faq_q3(inputs)
	if (locale === "it") return it_phred_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_phred_faq_q3(inputs)
	if (locale === "pt") return pt_phred_faq_q3(inputs)
	if (locale === "ja") return ja_phred_faq_q3(inputs)
	return zh_phred_faq_q3(inputs)
};